import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfigService } from '../../services/app-config.service';
import jwt_decode from 'jwt-decode';
import { JwtService } from '../../services/jwt.service';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { UserService } from '../../services/user.service';
import { PhoneNumberDialogComponent } from '../../dialog/phone-number-dialog/phone-number-dialog.component';
import { MatDialog, MatDialogModule } from "@angular/material/dialog";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {

  currentUrl: string;
  checkLogin: string;
  isSignIn: boolean = false;

  googleCustomer = new GoogleCustomer();

  constructor(
    // private ngZone: NgZone,
    public dialog: MatDialog,
    // // private authService: AuthService,
    private userService: UserService,
    // private toastService: ToastService,
    // private router: Router,
    private route: ActivatedRoute,
    // private OAuth: SocialAuthService,
    // private apiFactory: APIFactoryEndPoints,
    // private localStorage: LocalStorageService,
    private appConfig: AppConfigService,
    private jwtService: JwtService,
  ) {
    // this.createUser = new User();
    // window.location.href = environment.loginLogoutUrl + "signin?cnt=1&source=" + environment.source + "&force_login=true";
  }

  ngOnInit() {
    // this.currentUrl = getWindow().location.hostname;
    this.currentUrl = window.location.host.replace(':', '');

    // 🔹 Step 1: detect source (like /login/checkout or query param ?s=checkout)
    this.route.params.subscribe((data) => {
      const fromParam = data['id'];
      if (fromParam) {
        // coming from checkout, customized, etc.
        this.checkLogin = fromParam;
        localStorage.setItem('post-login-source', fromParam);
      }
    });

    this.route.queryParams.subscribe((params) => {
      let token = params['id_token'];
      let accessToken = params['access_token'];
      console.log(token)
      // fallback parsing if Angular missed it
      if (!token) {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get('id_token');
        accessToken = urlParams.get('access_token');
      }

      // console.log('Token =', token);

      // 🔹 Step 2: handle login token (after redirect)
      if (token) {
        try {
          console.log(token)
          const decoded: any = jwt_decode(token);
          console.log('Decoded JWT:', decoded);
          this.jwtService.saveAccessToken(accessToken);
          this.callGoogleLogin(decoded);
        } catch (error) {
          console.error('Invalid token:', error);
        }
      } else {
        // 🔹 Step 3: redirect to external login if not authenticated
        window.location.href = this.appConfig.setting.loginLogoutUrl + 'signin?cnt=1&source=' + this.appConfig.setting.source + '&force_login=true';
      }
    });


    // let id = this.route.snapshot.paramMap.get("checkout");
    // this.route.params.subscribe((data) => {
    //   this.checkLogin = data["id"];
    // });
    // this.route.queryParams.subscribe(params => {
    //   const hasSource = 's' in params;
    //   if (hasSource) {
    //     this.checkLogin = params['s'];
    //   }
    // });
    // console.log("CheckLogin=" + this.checkLogin);


    // this.googleAuthSDK();

    // console.log(id);
    // this.getLocationForGoogle();
    // this.getLocationForFB();

    //this.googleAuthSDK();

    // const dialogRef = this.dialog.open(PhoneNumberDialogComponent, {
    //   width: "250px",
    //   data: this.googleCustomer,
    // });
    // google.accounts.id.initialize({
    //   client_id: environment.googleClientId,
    //   callback: this.handleCredentialResponse.bind(this),
    //   auto_select: false,
    //   cancel_on_tap_outside: true,

    // });
    // // @ts-ignore
    // google.accounts.id.renderButton(
    // // @ts-ignore
    // document.getElementById("google-button"),
    //   { theme: "outline", size: "large", width: "100%" }
    // );
    // // @ts-ignore
    // google.accounts.id.prompt((notification: PromptMomentNotification) => {});
  }

  callGoogleLogin(googleAuthUser: any) {
    console.log(googleAuthUser)
    this.isSignIn = false;

    this.isSignIn = true;
    this.googleCustomer.id = googleAuthUser.email;
    this.googleCustomer.name = googleAuthUser.name;
    this.googleCustomer.email = googleAuthUser.email;
    this.googleCustomer.firstName = googleAuthUser.given_name;
    this.googleCustomer.lastName = googleAuthUser.family_name;
    this.googleCustomer.idToken = googleAuthUser.email;
    this.googleCustomer.authToken = googleAuthUser.nbf;
    this.googleCustomer.provider = "GOOGLE";

    console.log(this.googleCustomer);

    localStorage.setItem("google_email", JSON.stringify(this.googleCustomer.email));
    localStorage.setItem("google_item", JSON.stringify(this.googleCustomer.name));
    localStorage.setItem("google_id", JSON.stringify(this.googleCustomer.id));
    localStorage.setItem("google_provider", JSON.stringify(this.googleCustomer.provider));
    this.userService.setCheckLoggedIn(this.checkLogin);
    const dialogRef = this.dialog.open(PhoneNumberDialogComponent, {
      // width: "250px",
      // data: this.googleCustomer,
      width: '450px', // Increased from 250px
      maxWidth: '95vw', // Responsive fallback
      data: this.googleCustomer,
      panelClass: 'custom-dialog-container' // Optional: for removing default padding
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
      window.location.reload();
    });
    if (null == this.googleCustomer) {
      this.isSignIn = false;
    }
  }
}
